<template>
  <div>
    <h3>Mes questions</h3>
    <ListQuestions v-if="myQuestions.length > 0" :questions="myQuestions" removable="true" @remove-question="deleteQuestion"></ListQuestions>
    <p v-else>
      Vous n'avez pas encore créé de questions...
    </p>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ListQuestions from "./ListQuestions";

export default {
  name: "MyQuestions",
  components: { ListQuestions },
  computed: {
    ...mapState("questions", ["myQuestions"])
  },
  methods: {
    ...mapActions("questions", ["deleteQuestion", "bindMyQuestions"])
  },
  mounted: function() {
    this.bindMyQuestions();
  }
};
</script>

<style>
</style>